module.exports = __webpack_public_path__ + "img/icon-land.e9804204.svg";